import { get } from 'lodash';
import {
  currentPrimaryLanguage,
  currentSelectedLanguage,
} from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { currentSelectedSize } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewSizeContainer/slice';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { getState } from 'src/store';
import {
  SYS_LANGUAGE,
  STORE_DATE_FORMAT,
  STORE_TIME_FORMAT,
  STORE_TIMEZONE,
  STORE_UTC,
  CURRENT_SC_DATE_FORMAT,
  CURRENT_SC_TIME_FORMAT,
  CURRENT_SC_TIMEZONE,
  CURRENT_SC_UTC,
} from 'src/tools/constant';
import { generateKey } from 'src/tools/getUserInfo';
import { ELang } from 'src/types/common/language';
import GeneralJSON from '../../portal-bundle.json';
import moment from 'moment';

const getCurrentStyle = () => {
  const state = getState();
  const style = currentSelectedStyle()(state);
  return { style };
};

const getCurrentSize = () => {
  const state = getState();
  const size = currentSelectedSize()(state);
  return { size };
};
const getCurrentLanguage = () => {
  const state = getState();
  const language = currentSelectedLanguage()(state);
  const primaryLanguage = currentPrimaryLanguage()(state);
  return { language, primaryLanguage };
};

const generalValuePickerAccordingLanguage = (data) => {
  const { cn, hk, gb } = data || {};
  const language = getCurrentLanguage();

  const current = get(language, 'language');
  if (current == ELang['en-GB']) {
    return gb;
  }
  if (current == ELang['zh-CN']) {
    return cn;
  }
  if (current == ELang['zh-HK']) {
    return hk;
  }
  return null;
};

export const i18nGet = (a, b, c?) => {
  return get(a, b, c) || 'Loading';
};

export const replaceI18nVariables = (str: string, ...replaceStr: any[]) => {
  if (!str) {
    return '';
  }
  let n = -1;
  return str.replace(/\${[a-zA-Z0-9]+}/g, (s: string) => {
    n += 1;

    return replaceStr[n];
  });
};

export const replaceI8nSequence = (str, ...replaceStr) => {
  const text = 'text';
  return str.replace(new RegExp(`\\\${${text}[0-9]+}`, 'g'), (s) => {
    return replaceStr[Number(s.slice(text.length + 2, -1)) - 1] || '';
  });
};

const getDefaultLanguage = () => {
  const browserLang =
    get(navigator, 'language') || get(navigator, 'userLanguage') || 'en-GB';
  const languageList = ['zh-HK', 'zh-CN', 'en-GB'];
  if (languageList.includes(browserLang)) {
    return browserLang;
  } else {
    if (browserLang.startsWith('en')) {
      return 'en-GB';
    }
    if (browserLang.startsWith('zh')) {
      return 'zh-HK';
    }
    return 'en-GB';
  }
};

const getLangFromLocalStorage = () => {
  const k = generateKey(SYS_LANGUAGE);
  const lang =
    localStorage.getItem(k) !== '' || !!!localStorage.getItem(k)
      ? localStorage.getItem(k)
      : getDefaultLanguage();

  return lang;
};

const getGeneralJSON = () => {
  //const k = generateKey(SYS_LANGUAGE);
  const lang = getLangFromLocalStorage();

  //const langInJs = JSON.parse(lang);
  try {
    const langInJSON = JSON.parse(lang);
    return get(GeneralJSON, langInJSON);
  } catch (e) {
    return get(GeneralJSON, lang);
  }
};

const getI18nFromGeneral = (k: string) => {
  const json = getGeneralJSON();
  return get(json, k) || 'Loading';
};

const getAreaCodeUuid = (o) => {
  return get(o, 'uuid');
};

const getAreaCode = (o) => {
  return get(o, 'areaCode');
};

const getAreaCodeInfo = (areaCodes, uuid) => {
  return areaCodes.find((i) => i.uuid === uuid);
};

const handleOnFormatDate = (date, format, timezone?) => {
  try {
    const momentInstance = timezone ? moment(date).tz(timezone) : moment(date);
    const formattedDate = momentInstance.format(format);
    return formattedDate === 'Invalid date' ? '' : formattedDate;
  } catch (e) {
    return date || '-';
  }
};

class StoreTimeFormatRelated {
  handleOnGetStoreTimezone() {
    const k = generateKey(STORE_UTC);
    const timezone = localStorage.getItem(k);
    return timezone;
  }
  handleOnGetStoreDateFormat() {
    const k = generateKey(STORE_DATE_FORMAT);
    const dateFormat = localStorage.getItem(k);
    return dateFormat;
  }
  handleOnGetStoreTimeFormat() {
    const k = generateKey(STORE_TIME_FORMAT);
    const timeFormat = localStorage.getItem(k);
    return timeFormat;
  }
  handleOnFormatStoreDate(date) {
    const format = this.handleOnGetStoreDateFormat();
    return handleOnFormatDate(date, format);
  }
  handleOnFormatStoreTime(time) {
    const format = this.handleOnGetStoreTimeFormat();
    return handleOnFormatDate(time, format);
  }
  handleOnFormatStoreTimeAndDate(dt) {
    const df = this.handleOnGetStoreDateFormat();
    const tf = this.handleOnGetStoreTimeFormat();
    const format = `${df} ${tf}`;
    return handleOnFormatDate(dt, format);
  }
}

class CurrentSalesChannelTimeFormatRelated {
  handleOnGetCurrentSCTimezone() {
    const k = generateKey(CURRENT_SC_UTC);
    const timezone = sessionStorage.getItem(k);
    return timezone;
  }
  handleOnGetCurrentSCDateFormat() {
    const k = generateKey(CURRENT_SC_DATE_FORMAT);
    const dateFormat = sessionStorage.getItem(k);
    return dateFormat;
  }
  handleOnGetCurrentSCTimeFormat() {
    const k = generateKey(CURRENT_SC_TIME_FORMAT);
    const timeFormat = sessionStorage.getItem(k);
    return timeFormat;
  }
  handleOnFormatCurrentSCDate(date) {
    const format = this.handleOnGetCurrentSCDateFormat();
    return handleOnFormatDate(date, format);
  }
  handleOnFormatCurrentSCTime(time) {
    const format = this.handleOnGetCurrentSCTimezone();
    return handleOnFormatDate(time, format);
  }
  handleOnFormatCurrentSCTimeAndDate(dt) {
    const df = this.handleOnGetCurrentSCDateFormat();
    const tf = this.handleOnGetCurrentSCTimezone();
    const format = `${df} ${tf}`;
    return handleOnFormatDate(dt, format);
  }
}
// store - get
const handleOnGetStoreTimezoneUTC = () => {
  const k = generateKey(STORE_UTC);
  const timezoneutc = localStorage.getItem(k) || '';
  return timezoneutc;
};

const handleOnGetStoreTimezone = () => {
  const k = generateKey(STORE_TIMEZONE);
  const timezone = localStorage.getItem(k) || '';
  return timezone;
};

const handleOnGetStoreDateFormat = () => {
  const k = generateKey(STORE_DATE_FORMAT);
  const dateFormat = localStorage.getItem(k) || '';
  return dateFormat;
};
const handleOnGetStoreTimeFormat = () => {
  const k = generateKey(STORE_TIME_FORMAT);
  const timeFormat = localStorage.getItem(k) || '';
  return timeFormat;
};

// saleschannel - get
const handleOnGetCurrentSCTimezoneUTC = () => {
  const k = generateKey(CURRENT_SC_UTC);
  const timezoneUTC = sessionStorage.getItem(k) || '';
  return timezoneUTC;
};

const handleOnGetCurrentSCTimezone = () => {
  const k = generateKey(CURRENT_SC_TIMEZONE);
  const timezone = sessionStorage.getItem(k) || '';
  return timezone;
};

const handleOnGetCurrentSCDateFormat = () => {
  const k = generateKey(CURRENT_SC_DATE_FORMAT);
  const dateFormat = sessionStorage.getItem(k) || '';
  return dateFormat;
};
const handleOnGetCurrentSCTimeFormat = () => {
  const k = generateKey(CURRENT_SC_TIME_FORMAT);
  const timeFormat = sessionStorage.getItem(k) || '';
  return timeFormat;
};

//store - handle
const handleOnFormatStoreDate = (date) => {
  const format = handleOnGetStoreDateFormat();
  const tz = handleOnGetStoreTimezone();
  return handleOnFormatDate(date, format, tz);
};
const handleOnFormatStoreTime = (time) => {
  const format = handleOnGetStoreTimeFormat();
  const tz = handleOnGetStoreTimezone();
  return handleOnFormatDate(time, format, tz);
};
const handleOnFormatStoreTimeAndDate = (dt) => {
  const df = handleOnGetStoreDateFormat();
  const tf = handleOnGetStoreTimeFormat();
  const format = `${df} ${tf}`;
  return handleOnFormatDate(dt, format);
};

const handleOnFormatStoreTimeAndDateWithTimezone = (dt) => {
  const df = handleOnGetStoreDateFormat();
  const tf = handleOnGetStoreTimeFormat();
  const tz = handleOnGetStoreTimezone();
  const format = `${df} ${tf}`;
  return handleOnFormatDate(dt, format, tz);
};

//salechannel - handle
const handleOnFormatCurrentSCDate = (date) => {
  const format = handleOnGetCurrentSCDateFormat();
  return handleOnFormatDate(date, format);
};
const handleOnFormatCurrentSCTime = (time) => {
  const format = handleOnGetCurrentSCTimezoneUTC();
  return handleOnFormatDate(time, format);
};
const handleOnFormatCurrentSCTimeAndDate = (dt) => {
  const df = handleOnGetCurrentSCDateFormat();
  const tf = handleOnGetCurrentSCTimeFormat();
  const format = `${df} ${tf}`;
  return handleOnFormatDate(dt, format);
};
const handleOnFormatCurrentSCTimeAndDateWithTimezone = (dt) => {
  const df = handleOnGetCurrentSCDateFormat();
  const tf = handleOnGetCurrentSCTimeFormat();
  const tz = handleOnGetCurrentSCTimezone();
  const format = `${df} ${tf}`;
  return handleOnFormatDate(dt, format, tz);
};

const generateMomentTime = (date: string, time: string, timezone: string) => {
  if (!date) {
    return moment('invalid date');
  } else {
    const dateString = `${date} ${time}`;
    return moment.tz(dateString, timezone);
  }
};

function hasCircleValid(
  availableLanguages: any[],
  curTag: string,
  nextSourceTag: string,
) {
  const langMap = new Map((availableLanguages || []).map((l) => [l['tag'], l]));
  const visited = new Set<string>();

  for (let tag = nextSourceTag; tag; ) {
    if (visited.has(tag)) break;
    visited.add(tag);

    if (tag === curTag) return true;

    const next = langMap.get(tag)?.translationSetting?.sourceLanguage;
    if (!next) break;
    tag = next;
  }

  return false;
}

//handleI18nInRequest
export {
  generalValuePickerAccordingLanguage,
  generateMomentTime,
  getAreaCode,
  getAreaCodeInfo,
  getAreaCodeUuid,
  getCurrentLanguage,
  getCurrentSize,
  getCurrentStyle,
  getDefaultLanguage,
  getGeneralJSON,
  getI18nFromGeneral,
  getLangFromLocalStorage,
  handleOnGetStoreTimezoneUTC,
  handleOnGetStoreTimezone,
  handleOnGetStoreDateFormat,
  handleOnGetCurrentSCTimezone,
  handleOnGetCurrentSCTimezoneUTC,
  handleOnFormatStoreDate,
  handleOnFormatStoreTime,
  handleOnFormatStoreTimeAndDate,
  handleOnFormatStoreTimeAndDateWithTimezone,
  handleOnFormatCurrentSCDate,
  handleOnFormatCurrentSCTime,
  handleOnFormatCurrentSCTimeAndDate,
  handleOnFormatCurrentSCTimeAndDateWithTimezone,
  handleOnGetCurrentSCTimeFormat,
  handleOnGetCurrentSCDateFormat,
  StoreTimeFormatRelated,
  CurrentSalesChannelTimeFormatRelated,
  handleOnFormatDate,
  hasCircleValid,
};
//import { getAreaCodeUuid, getAreaCode } from 'src/tools/tools';
